import { validateRuntimeConfig } from './configSchema';

let activeConfig = null;

export const initConfig = ({
  runtimeConfig = {},
  env = process.env,
} = {}) => {
  if (activeConfig) {
    throw new Error('Application configuration has already been initialized.');
  }

  activeConfig = validateRuntimeConfig({ runtimeConfig, env });
  return activeConfig;
};

export const getConfig = () => {
  if (!activeConfig) {
    throw new Error(
      'Application configuration is not initialized. Call initConfig() during bootstrap before using API modules.'
    );
  }

  return activeConfig;
};

export const getApiBaseUrl = () => getConfig().apiBaseUrl;

export const resetConfigForTests = () => {
  activeConfig = null;
};
